// Ostatnio wybrane izby (85% userów filtra wybiera jedną). Cookie, nie localStorage — proxy.ts czyta je
// po stronie serwera i od razu przekierowuje na URL z filtrem, bez drugiego ładowania danych.
export const MEDICAL_CHAMBER_COOKIE = "internship-map-medical-chamber";
